var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1032_19468)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.4527 0.0159268C2.91081 0.0159268 0.0253906 2.90135 0.0253906 6.44324C0.0253906 9.98513 2.91097 12.8705 6.4527 12.8705C7.98455 12.8705 9.39163 12.3291 10.4977 11.4299L14.8471 15.7793C15.1067 16.0389 15.5294 16.0389 15.789 15.7793C16.0486 15.5197 16.0486 15.104 15.789 14.8443L11.4396 10.4949C12.3405 9.38835 12.8802 7.97663 12.8802 6.44312C12.8802 2.90123 9.99463 0.0158081 6.4529 0.0158081L6.4527 0.0159268ZM6.4527 1.34572C9.27583 1.34572 11.5501 3.62015 11.5501 6.44316C11.5501 9.26616 9.27571 11.5406 6.4527 11.5406C3.6297 11.5406 1.35526 9.26616 1.35526 6.44316C1.35526 3.62015 3.6297 1.34572 6.4527 1.34572Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1032_19468"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.92fb0e3c5401076c777ff6ea19e39390.svg";
export { ForwardRef as ReactComponent };